import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { AddIcon } from '../../../../../../../../design/static/icons/AddIcon';

interface Props {
  onShowModal: () => void;
}

export const AddMarkingToolButton = observer((props: Props): ReactElement => {
  const { t } = useTranslator();
  return (
    <Button
      size='sm'
      variant='outlined'
      onClick={props.onShowModal}
      startDecorator={<AddIcon />}
    >
      {t('add')}
    </Button>
  );
});
